export const classes = {
  wrapper: 'px-6 z-20 place-center',
  playWrapper: 'mr-4 flex items-center',
  addWrapper: 'ml-4',
  addButton: 'ml-0',
};
